<template>
  <div>
    <Retry
      v-if="loadingConfig === -1"
      class="global-retry"
      :loading="loadingConfig === true"
      @retry="getGlobalConfig"
    />
    <slot v-else />
  </div>
</template>

<script>
import { storeToRefs } from 'pinia'
import { useGlobalConfigStore } from '@ms/stores/globalConfig'
import Retry from '@ms/components/Retry.vue'

export default {
  components: {
    Retry
  },
  setup() {
    const store = useGlobalConfigStore()
    const { loadingConfig } = storeToRefs(store)
    const { getGlobalConfig } = store
    return {
      loadingConfig,
      getGlobalConfig
    }
  },
  created() {
    this.getGlobalConfig()
  }
}
</script>

<style lang="scss" scoped>
.global-retry {
  padding-top: 28vh;
}
</style>
